if (!customElements.get('g6-purchase-panel')) {
  customElements.define('g6-purchase-panel', class extends HTMLElement {
    connectedCallback() {
      this.onVariant = event => {
        if (String(event.detail?.data?.productId) !== this.dataset.productId) return;
        const source = Array.from(event.detail.data.html.querySelectorAll('g6-purchase-panel')).find(panel => panel.dataset.blockId === this.dataset.blockId);
        const price = source?.querySelector('.g6-panel-price');
        if (price) this.querySelector('.g6-panel-price').replaceChildren(...Array.from(price.childNodes).map(node => node.cloneNode(true)));
      };
      document.addEventListener('variant:update', this.onVariant);
    }
    disconnectedCallback() {
      document.removeEventListener('variant:update', this.onVariant);
    }
  });
}
